const SHARE_IMAGE =
  'https://firebasestorage.googleapis.com/v0/b/afigr-12814.appspot.com/o/logo%20(8).webp?alt=media&token=c998704f-fd95-4061-bd08-a65dad1e9cef';

const DEFAULT_META = {
  en: {
    title: 'Home | Al Faisal Group',
    description:
      'Al Faisal International Group is one of the distinctive and leading monuments in Egypt since it has adopted since its inception on the principle of credibility and attention to the customer in every way.',
  },
  ar: {
    title: 'مجموعة آل فيصل الدولية',
    description:
      'تعتبر مجموعة الفيصل العالمية من المعالم المميزة والرائدة في مصر منذ أن اعتمدت منذ نشأتها على مبدأ المصداقية والاهتمام بالعميل في كل مكان.',
  },
};

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export function setPageMeta({ title, description, url, image, locale = 'ar' }) {
  const img = image || SHARE_IMAGE;
  const desc =
    description ||
    (DEFAULT_META[locale] || DEFAULT_META.ar).description;

  if (title) {
    document.title = title;
    setMeta('name', 'title', title);
    setMeta('property', 'og:title', title);
    setMeta('property', 'twitter:title', title);
  }

  setMeta('name', 'description', desc);
  setMeta('property', 'og:description', desc);
  setMeta('property', 'twitter:description', desc);

  if (url) {
    setMeta('property', 'og:url', url);
    setMeta('property', 'twitter:url', url);
  }

  setMeta('property', 'og:image', img);
  setMeta('property', 'twitter:image', img);

  const thumb = document.querySelector('link[itemprop="thumbnailUrl"]');
  if (thumb) thumb.setAttribute('href', img);
}

export function setDefaultPageMeta(locale = 'ar') {
  const defaults = DEFAULT_META[locale] || DEFAULT_META.ar;
  setPageMeta({
    title: defaults.title,
    description: defaults.description,
    url: `https://www.afigr.com/${locale}`,
    locale,
  });
}

export { SHARE_IMAGE, DEFAULT_META };
